const { party } = require('./base');

const invoiceParty = Object.assign({}, party);
const invoiceFeatures = {
  DEFAULT: 'default',
  TWO_STEP_APPROVAL: 'invoice_two_step_approval',
  NON_FREIGHT_BILL: 'non_freight_bill',
  FREIGHT_BILL: 'freight_bill',
};

const invoiceStatus = {
  CUSTOM: 0,
  GENERATED: 1,
  CHECKED: 2,
  APPROVED: 3,
  RETURNED: 4,
  RE_SUBMITTED: 5,
  POSTED: 6,
  PAID: 7,
  REJECTED: 8,
  ON_HOLD: 9,
  PARTIAL: 12,
};

const invoiceStatusV1List = [
  {
    id: 1,
    name: 'pending',
    sortOrder: 1,
    invoice_label: 'Generated',
  },
  {
    id: 2,
    name: 'checked',
    sortOrder: 2,
    invoice_label: 'Checked',
  },
  {
    id: 3,
    name: 'invoice_accepted',
    sortOrder: 5,
    invoice_label: 'Approved',
  },
  {
    id: 4,
    name: 'invoice_rejected',
    sortOrder: 3,
    invoice_label: 'Rejected',
  },
  {
    id: 5,
    name: 'physical_document_pending',
    sortOrder: 7,
    invoice_label: 'Physical Document Pending',
  },
  {
    id: 6,
    name: 'physical_document_received',
    invoice_label: 'Physical Document Received',
    sortOrder: 6,
    label_102: 'Pending',
  },

  {
    id: 7,
    name: 'librarian_accepted',
    sortOrder: 9,
    invoice_label: 'Librarian Accepted',
    label_103: 'Pending',
  },
  {
    id: 8,
    name: 'librarian_rejected',
    sortOrder: 8,
    invoice_label: 'Librarian Rejected',
  },
  {
    id: 9,
    name: 'processing',
    sortOrder: 10,
    invoice_label: 'Posted',
  },
  {
    id: 10,
    name: 'on_hold',
    sortOrder: 11,
    invoice_label: 'On Hold',
  },
  {
    id: 11,
    name: 'payment_accepted',
    sortOrder: 13,
    invoice_label: 'Paid',
  },
  {
    id: 12,
    name: 'payment_rejected',
    sortOrder: 12,
    invoice_label: 'Pay Rejected',
  },
  {
    id: 13,
    name: 'payment_re_submitted',
    sortOrder: 4,
    invoice_label: 'Re Submitted',
  },
  {
    id: 14,
    name: 'payment_ready_for_voucher',
    invoice_label: 'Invoice Updates',
  },
  {
    id: 15,
    name: 'voucher_created',
    invoice_label: 'Voucher Generated',
  },
];

const invoiceStatusList = [{
  id: 1,
  name: 'generated',
  label: 'Generated',
  parent: null, // Root status of invoice flow
  actionAllowedParties: [invoiceParty.TRANSPORTER],
},
{
  id: 2,
  name: 'checked',
  label: 'Checked',
  parent: [{
    ids: [1, 5],
    features: invoiceFeatures.DEFAULT,
  },
  {
    ids: [1, 5, 8],
    features: invoiceFeatures.TWO_STEP_APPROVAL,
  }],
  actionAllowedParties: [invoiceParty.SHIPPER],
},
{
  id: 3,
  name: 'invoice_approved',
  label: 'Approved',
  parent: [{
    ids: [1, 2, 5],
    features: invoiceFeatures.DEFAULT,
  },
  {
    ids: [2],
    features: invoiceFeatures.TWO_STEP_APPROVAL,
  }],
  actionAllowedParties: [invoiceParty.SHIPPER],
},
{
  id: 4,
  name: 'invoice_returned',
  label: 'Returned',
  parent: [{
    ids: [1, 2, 5],
    features: invoiceFeatures.DEFAULT,
  },
  {
    ids: [1, 5, 8],
    features: invoiceFeatures.TWO_STEP_APPROVAL,
  }],
  actionAllowedParties: [invoiceParty.SHIPPER],
},
{
  id: 5,
  name: 're_submitted',
  label: 'Resubmitted',
  parent: [{
    ids: [4],
    features: invoiceFeatures.DEFAULT,
  }],
  actionAllowedParties: [invoiceParty.TRANSPORTER],
},
{
  id: 6,
  name: 'posted',
  label: 'Posted',
  parent: [{
    ids: [3],
    features: invoiceFeatures.DEFAULT,
  }],
  actionAllowedParties: [invoiceParty.SHIPPER],
},
{
  id: 7,
  name: 'paid',
  label: 'Paid',
  parent: [{
    ids: [3, 6, 9, 12], 
    features: invoiceFeatures.DEFAULT,
  }],
  actionAllowedParties: [invoiceParty.SHIPPER],
},
{ // Invoice - Approver rejected
  id: 8,
  name: 'rejected',
  label: 'Rejected',
  parent: [{
    ids: [2],
    features: invoiceFeatures.TWO_STEP_APPROVAL,
  }],
  actionAllowedParties: [invoiceParty.SHIPPER],
},
{
  id: 9,
  name: 'on_hold',
  label: 'On_Hold',
  parent: [{
    ids: [3, 6, 12],
    features: invoiceFeatures.DEFAULT,
  }],
  actionAllowedParties: [invoiceParty.SHIPPER],
},
{
  id: 10,
  name: 'invoice_cancelled',
  label: 'Cancelled',
  parent: [{
    ids: [1, 2, 4, 5, 8],
    features: invoiceFeatures.FREIGHT_BILL,
  },
  {
    ids: [4],
    features: invoiceFeatures.DEFAULT,
  }],
  actionAllowedParties: [invoiceParty.SHIPPER, invoiceParty.TRANSPORTER],
},
{
  id: 11, 
  name: 'invoice_custom',
  label: 'Custom',
  parent: null, // Root status of invoice flow
  actionAllowedParties: [invoiceParty.SHIPPER, invoiceParty.TRANSPORTER],
},
{
  id: 12,
  name: 'partial',
  label: 'Partial',
  parent: [{
    ids: [3, 6, 9, 12],
    features: invoiceFeatures.DEFAULT,
  }],
  actionAllowedParties: [invoiceParty.SHIPPER],
},
// Filter Group Id
{
  id: 1001,
  name: 'generated',
  label: 'Generated',
},
{
  id: 1002,
  name: 'approved',
  label: 'Approved',
},
{
  id: 1003,
  name: 'invoice_returned',
  label: 'Returned',
},
{
  id: 1004,
  name: 're-submitted',
  label: 'Re-Submitted',
},
{
  id: 1005,
  name: 'paid',
  label: 'Paid',
},
{
  id: 1006,
  name: 'cancelled',
  label: 'Cancelled',
},
{
  id: 1009,
  name: 'on_hold',
  label: 'On Hold',
},{
  id: 1010, 
  name: 'partial',
  label: 'Partial',
}
];

// transporter groups for invoice status
const invoiceStatusMapping = {
  1001: [1],
  1002: [3, 6],
  1003: [4],
  1004: [5],
  1005: [7],
  1006: [10],
  1007: [2],
  1008: [8],
  1009: [9], 
  1010: [12],
};

const gstType = {
  FCM: 1,
  RCM: 2,
  // NONE: 3,
};

const gstTypes = [
  { id: 1, label: 'Forward', value: 1 },
  { id: 2, label: 'Reverse', value: 2 },
  { id: 3, label: 'None', value: 3, hidden: true },
];

const billToPartyTypes = [
  { id: 0, label: 'Source Depot', value: 'source' },
  { id: 1, label: 'Destination Depot', value: 'destination' },
];

const gstSplitType = {
  INTER_STATE: 1,
  INTRA_STATE: 2,
};

const invoiceType = {
  CLEAN: 1,
  NON_CLEAN: 2,
  AGED: 3,
};

const erpStatusPostingType = {
  POSTED: 1,
  ON_HOLD: 2,
  PAID: 3,
  PARTIAL: 4,
};

const invoice = {
  exportLimit: 50,
  exportNumber: 14,
  excelSheetname: 'Invoices',
  queryLimit: 1000,
};

const amountType = {
  TRANSPORTER: 'transporter',
  CLIENT: 'client',
};

const InvoiceStatusUpdateHeaders = {
  Type: 'type',
  'Reference Number': 'invoiceNumber',
  'Document Number': 'documentNumber',
  'Updated date': 'documentUpdatedDate',
  'Document Type': 'documentType',
  'Amount Paid': 'partialAmountPaid',
};


const getInvoiceSource = () => ({
  PAYMENT: 1,
  FREIGHT_BILL: 2,
});

const billToParty = {
  SOURCE: 'source',
  DESTINATION: 'destination',
};

const InvoiceNotificationActions = {
  GENERATION: 'generation',
  RETURN: 'return',
  APPROVAL: 'approval',
};

const InvoiceMovementType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  INWARD: 'inward',
  RETURN: 'return',
  ROUNDTRIP_RETURN: 'roundtrip_return',
};

const InvoiceLocationType = {
  SOURCE: 'source',
  DESTINATION: 'destination',
}
const eInvoiceValidateFields = [
  {
    localFieldKey: 'invoice_number',
    masterIndiaFieldKey:'document_details.number',
    mismatchedValue: "Invoice Number",
  },
  {
    localFieldKey: 'invoice_amount',
    masterIndiaFieldKey:'value_details.total_value',
    mismatchedValue: "Invoice Amount",
  },
  {
    localFieldKey: 'gst_number',
    masterIndiaFieldKey:'seller_details.gstin',
    mismatchedValue: "Transporter GSTIN",
  },
  {
    localFieldKey: 'gstin',
    masterIndiaFieldKey:'buyer_details.gstin',
    mismatchedValue: "Shipper GSTIN",
  },
  {
    localFieldKey: 'invoice_date',
    masterIndiaFieldKey:'document_details.date',
    mismatchedValue: "Invoice Date",
  },
];

const invoicePdfTypes = {
  INVOICE: 'INVOICE',
  TAX_INVOICE: 'TAX INVOICE',
  PROFORMA_INVOICE: 'PROFORMA INVOICE',
} 
module.exports = {
  amountType,
  erpStatusPostingType,
  gstType,
  gstTypes,
  gstSplitType,
  invoice,
  invoiceParty,
  invoiceType,
  invoiceStatus,
  invoiceStatusList,
  invoiceStatusMapping,
  InvoiceStatusUpdateHeaders,
  getInvoiceSource,
  billToPartyTypes,
  billToParty,
  InvoiceNotificationActions,
  InvoiceMovementType,
  InvoiceLocationType,
  invoiceStatusV1List,
  eInvoiceValidateFields,
  invoicePdfTypes
};
